import React from 'react'
import {Box} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {renderLayoutsSwitch} from '../../utils/contentRenderer'

const StandardPage = (content) => {
    return (
        <Box>
            {content?.MainContentArea?.map((content, contentIndex) => {
                return (
                    <React.Fragment key={contentIndex}>
                        {renderLayoutsSwitch(content)}
                    </React.Fragment>
                )
            })}
        </Box>
    )
}

StandardPage.displayName = 'StandardPage'

StandardPage.propTypes = {
    content: PropTypes.object
}

export default StandardPage
